<div class="container">
  <ghs-header [standalone]="true"></ghs-header>
  <div class="menu">
    <label>
      <span [ghs-label]="'settings.edition'"></span>
      <select [(ngModel)]="edition" (change)="update(); updateQueryParams()">
        <option *ngFor="let edition of gameManager.editions(true)" [value]="edition">
          <span [ghs-label]="'data.edition.' + edition"></span>
        </option>
      </select>
    </label>
    <label>
      <input type="checkbox" [(ngModel)]="character" (change)="update()">
      <span [ghs-label]="'tools.decks.character'"></span>
    </label>
    <label>
      <input type="checkbox" [checked]="settingsManager.settings.calculate"
        (change)="settingsManager.toggle('calculate');update();">
      <span [ghs-label]="'settings.calc'"></span>
    </label>
    <label *ngIf="settingsManager.settings.calculate">
      <input type="checkbox" [checked]="settingsManager.settings.calculateStats"
        (change)="settingsManager.toggle('calculateStats');update();">
      <span [ghs-label]="'settings.calcStats'"></span>
    </label>
    <label *ngIf="settingsManager.settings.calculate && !character">
      <input type="checkbox" [(ngModel)]="entity" (change)="update();updateQueryParams();">
      <span [ghs-label]="'tools.decks.entity'"></span>
    </label>
    <label *ngIf="settingsManager.settings.calculate && !character">
      <input type="checkbox" [(ngModel)]="elite" (change)="update()">
      <span [ghs-label]="'tools.decks.elite'"></span>
    </label>
    <label *ngIf="settingsManager.settings.calculate">
      <input type="number" min="0" max="7" [(ngModel)]="level" (change)="update()">
      <span [ghs-label]="'tools.decks.level'"></span>
    </label>
    <label>
      <input type="checkbox" [checked]="settingsManager.settings.fhStyle"
        (change)="settingsManager.toggle('fhStyle'); gameManager.uiChange.emit()">
      <span [ghs-label]="'settings.fhStyle'"></span>
    </label>
  </div>

  <div class="decks">
    <ng-container *ngIf="characters.length > 0">
      <div class="deck" *ngFor="let character of characters; let i = index;">
        <h2><span [ghs-label]="'data.character.' + character.edition + '.' + character.name"></span> <small
            *ngIf="character.name != deck(character).name">
            <span [ghs-label]="'data.deck.' + deck(character).name"></span>
          </small></h2>
        <ghs-ability class="bottom-actions" *ngFor="let ability of deck(character).abilities" [ability]="ability"
          [abilities]="deck(character).abilities" [character]="characters[i]" [flipped]="true">
        </ghs-ability>
      </div>
    </ng-container>
    <ng-container *ngIf="monsters.length > 0">
      <div class="deck" *ngFor="let monster of monsters; let i = index;">
        <h2><span [ghs-label]="'data.monster.' + monster.name"></span> <small
            *ngIf="monster.name != deck(monster).name">
            <span [ghs-label]="'data.deck.' + deck(monster).name"></span>
          </small></h2>
        <ghs-ability *ngFor="let ability of deck(monster).abilities" [ability]="ability"
          [abilities]="deck(monster).abilities" [monster]="monsters[i]" [flipped]="true"
          [ngClass]="{'bottom-actions' : ability.bottomActions && ability.bottomActions.length > 0}"></ghs-ability>
      </div>
    </ng-container>
  </div>
</div>